// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__BPufm","alert-warning":"alert_alert-warning__YjQIN","alert-error":"alert_alert-error__1EeGQ"};